import { Injectable, inject, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { ToastService } from '@core/toast/toast.service';

@Injectable({ providedIn: 'root' })
export class DetectIpSwitchService {
  private readonly authorizationService = inject(AuthorizationService);
  private readonly router = inject(Router);
  private readonly toastService = inject(ToastService);
  private readonly loginEvent = toSignal(this.authorizationService.onLogin);
  private hasDetectedIpSwitch = false;

  static readonly toastMessageTranslateKey = 'login.messages.ip-not-allowed';

  constructor() {
    this.resetIpSwitchOnLogin();
    this.showIpSwitchToastOnLogout();
  }

  shouldHandleIpSwitch(): boolean {
    return !this.hasDetectedIpSwitch && this.authorizationService.isAuthorized();
  }

  handleIpSwitch(): void {
    this.hasDetectedIpSwitch = true;
    this.router.navigate([ApplicationPath.Logout]);
  }

  private resetIpSwitchOnLogin(): void {
    effect(() => {
      if (this.loginEvent()) {
        this.hasDetectedIpSwitch = false;
      }
    });
  }

  private showIpSwitchToastOnLogout(): void {
    this.authorizationService.onLogout.pipe(filter(() => this.hasDetectedIpSwitch)).subscribe(() => {
      this.toastService.showErrorToast(DetectIpSwitchService.toastMessageTranslateKey);
    });
  }
}
